import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { en } from './locales/en';

/**
 * i18n bootstrap.
 *
 * - English is the only locale today; the structure exists so adding hi, ar
 *   etc. is a matter of dropping a new locale file in.
 * - Default + initial locale comes from AppConfig.localization.defaultLocale
 *   once it's loaded. Until then we fall back to 'en'.
 * - LanguageDetector reads from localStorage so the user's last choice
 *   survives reloads.
 */

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'utazzo.locale',
    },
    returnNull: false,
  });

export { i18n };
